import classNames from 'classnames'

import { colors } from 'shared/constants/values'

import s from './Info.module.scss'

const colorTypes = {
  corp: colors.corp,
  success: colors.green,
  info: colors.info,
  warn: colors.orange,
  error: colors.red,
}

type InfoProps = {
  children: React.ReactNode
  showBorder?: boolean
  type?: 'info' | 'warn' | 'corp' | 'error' | 'success'
  disableMargin?: boolean
}

export const Info = ({ children, showBorder = false, type = 'info', disableMargin = false }: InfoProps) => {
  const classes = classNames(s.info, {
    [s.border]: showBorder,
  })

  return (
    <div className={classes} style={{ borderColor: colorTypes[type], margin: disableMargin ? 0 : '24px 0' }}>
      <div className={s.line} style={{ backgroundColor: colorTypes[type] }} />
      <div className={s.childrenWrap}>{children}</div>
    </div>
  )
}
